
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Database } from "@/integrations/supabase/types";

type Novidade = Database["public"]["Tables"]["novidades"]["Row"];

interface NewsListProps {
  novidades: Novidade[];
  isLoading: boolean;
}

export const NewsList: React.FC<NewsListProps> = ({ novidades, isLoading }) => {
  return (
    <Card className="col-span-1 dark:bg-white">
      <CardHeader>
        <CardTitle className="dark:text-gray-600">Novidades</CardTitle>
        <CardDescription>
          Últimas atualizações e recursos adicionados
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        ) : novidades.length > 0 ? (
          <div className="space-y-4">
            {novidades.map((novidade) => (
              <div key={novidade.id} className="border-b pb-2">
                <h3 className="font-medium dark:text-gray-600">{novidade.titulo}</h3>
                <p className="text-sm text-gray-500">{novidade.descricao}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            Nenhuma novidade disponível no momento.
          </p>
        )}
      </CardContent>
    </Card>
  );
};
